import {
  ConstrainedObject,
  ConstraintItemType,
  ConstraintModifier,
  ConstraintModifierField,
} from '@Models';

export const allConstraintModifierByConstraint = (
  constrainedObjects: ConstrainedObject[],
  constraintId: string,
): ConstraintModifier[] => {
  return constrainedObjects.flatMap((constrainedObject) => {
    return constrainedObject.modifiers.filter(
      (modifier) =>
        modifier.field === ConstraintModifierField.Constraint &&
        modifier.childId === constraintId &&
        modifier.childType === ConstraintItemType.Constraint,
    );
  });
};
